import React, { Component } from 'react';
import { Form, Grid, Message } from 'semantic-ui-react';
import { reduxForm, Field } from 'redux-form';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';

import { TitledCard } from 'Components';
import { NutrientAnalysisFieldEnum as Fields } from 'Common/FieldEnum';
import { RangeDatePickerField, SelectField } from 'Common/SemanticWrapper';
import { NUTRIENT_ANALYSIS_REPORT_FORM_NAME } from 'Common/FormEnum';
import { DATE_FORMAT_FOR_UI, AnalysisDaysOptions } from 'Common/Constants';
import { MenuMealTypesEnum } from 'Common/Constants/Enumeration/MealTypesEnum';
import { AllOptionEnum } from 'Common/Constants/Enumeration/PropEnums';
import {
  makeSelectFieldOptionsFromEnum,
  rangeDateValidator,
} from 'Common/FormHelper';
import { SiteSelectField } from 'Common/ReduxFormFields';

const { ALL, ...mealTypesEnum } = MenuMealTypesEnum;
const mealTypesOptions = makeSelectFieldOptionsFromEnum(mealTypesEnum);

class NutrientAnalysisReportForm extends Component {
  static propTypes = {
    nutritionStandardOptions: PropTypes.array,
    noCycleMenusFound: PropTypes.bool,
    cycleMenuOptions: PropTypes.array,
    loadingNutritionStandards: PropTypes.bool,
    loadingCycleMenus: PropTypes.bool,
  };

  static defaultProps = {
    nutritionStandardOptions: [],
    noCycleMenusFound: false,
    cycleMenuOptions: [],
    loadingNutritionStandards: false,
    loadingCycleMenus: false,
  };

  render() {
    const {
      nutritionStandardOptions,
      noCycleMenusFound,
      cycleMenuOptions,
      loadingNutritionStandards,
      loadingCycleMenus,
    } = this.props;

    return (
      <Form name={NUTRIENT_ANALYSIS_REPORT_FORM_NAME}>
        <TitledCard title={'Filters'}>
          <Grid>
            <Grid.Row>
              <Grid.Column width="10">
                <Field
                  name={Fields.SiteId}
                  component={SiteSelectField}
                  allOption={AllOptionEnum.None}
                  style={{ marginBottom: '10px' }}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>
                <RangeDatePickerField
                  fromName={Fields.FromDate}
                  toName={Fields.ToDate}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={10}>
                <Field
                  label="Meal Type"
                  name={Fields.MealType}
                  component={SelectField}
                  options={mealTypesOptions}
                />
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column width="10">
                <Field
                  label={'Nutrition Standard'}
                  component={SelectField}
                  name={Fields.NutritionStandard}
                  options={nutritionStandardOptions}
                  disabled={!nutritionStandardOptions.length}
                  loading={loadingNutritionStandards}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </TitledCard>
        <TitledCard title={'Report Parameters'}>
          <Grid>
            <Grid.Row>
              <Grid.Column width="10">
                {noCycleMenusFound && (
                  <Message color="orange">
                    <p>No Cycle Menus found. Try adjusting the filters.</p>
                  </Message>
                )}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width="10">
                <Field
                  label={'Cycle Menu'}
                  component={SelectField}
                  name={Fields.CycleMenuId}
                  options={cycleMenuOptions}
                  disabled={!cycleMenuOptions.length}
                  loading={loadingCycleMenus}
                  className="shorter"
                />
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column width="10">
                <Field
                  label="Number of days"
                  name={Fields.Days}
                  component={SelectField}
                  type="text"
                  options={AnalysisDaysOptions}
                  fluid
                  upward
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <br />
          <br />
        </TitledCard>
      </Form>
    );
  }
}

const validate = (values) => {
  const errors = rangeDateValidator(
    values[Fields.FromDate],
    values[Fields.ToDate],
    {
      granularity: 'day',
      fromName: Fields.FromDate,
      toName: Fields.ToDate,
      fromLabel: 'From',
      toLabel: 'To',
      dateFormat: DATE_FORMAT_FOR_UI,
      strict: false,
    }
  );

  if (values[Fields.MealType] == null) {
    errors[Fields.MealType] = 'A Meal Type must be selected.';
  }

  if (!values[Fields.SiteId]) {
    errors[Fields.SiteIds] = 'A Site must be selected.';
  }

  if (!values[Fields.CycleMenuId]) {
    errors[Fields.CycleMenuId] = 'A Cycle Menu must be selected.';
  }

  return errors;
};

NutrientAnalysisReportForm = reduxForm({
  form: NUTRIENT_ANALYSIS_REPORT_FORM_NAME,
  validate,
  enableReinitialize: true,
})(withRouter(NutrientAnalysisReportForm));

export { NutrientAnalysisReportForm };



// WEBPACK FOOTER //
// ./src/pages/reports/menus/NutrientAnalysisReport/components/NutrientAnalysisReportForm.js